module.exports = __webpack_public_path__ + "img/location.c88fee02.svg";